export const CONVERSATION_ITEM_HEIGHT_NO_TAGS = 90; 